module.exports = __webpack_public_path__ + "img/video-4.ba9996a0.png";